import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { dailyCompetitionArticles } from '@/mocks/articles';

export default function DailyCompetitionSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full">
              {t('dailyCompetitionLabel')}
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              {t('dailyCompetitionTitle')}
            </h2>
          </div>
          <Link
            to="/category/daily-competition"
            className="hidden sm:flex items-center gap-1 text-sm text-foreground-500 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('viewAll')}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {dailyCompetitionArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group block bg-background-100 rounded-xl overflow-hidden cursor-pointer border border-background-200/70 hover:border-accent-300 transition-all duration-300"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <h4 className="text-sm font-medium text-foreground-900 leading-snug group-hover:text-accent-600 transition-colors line-clamp-2">
                  {article.title}
                </h4>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span>{t('views')} {article.viewCount.toLocaleString()}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}